/**
 * @generated SignedSource<<36b06da223f01ec11363496ab4df0b4d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsIntroduction_component$data = {
  readonly longtext: string | null | undefined;
  readonly shorttext: string | null | undefined;
  readonly title: string | null | undefined;
  readonly warning: string | null | undefined;
  readonly " $fragmentType": "FundsIntroduction_component";
};
export type FundsIntroduction_component$key = {
  readonly " $data"?: FundsIntroduction_component$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsIntroduction_component">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsIntroduction_component",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "shorttext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "longtext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "warning",
      "storageKey": null
    }
  ],
  "type": "FundsIntroduction",
  "abstractKey": null
};

(node as any).hash = "5c3337b0e14b4a89c91088a7ba35f349";

export default node;
